import type { RouteObject } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import Home from "@/pages/home/page";
import StoryDetail from "@/pages/story/page";
import CollectionPage from "@/pages/collection/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <PageLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "story/:slug", element: <StoryDetail /> },
      { path: "collection/:id", element: <CollectionPage /> },
      { path: "about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;